
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "iview/dist/styles/iview.css";
import { Icon } from "iview";
import { install } from "@/axios/https.js";
import Vuex from "vuex";
import store from "./store/index.js";
import uploader from "vue-simple-uploader";
// 解决ie兼容性
import promise from "es6-promise";
import "babel-polyfill";
import * as VueJsonp from "vue-jsonp";
import moment from "moment";
// Vue.use(VueJsonp1)
Vue.prototype.$VueJsonp = VueJsonp;

import qs from "qs";
Vue.prototype.$qs = qs;
Vue.prototype.$moment = moment;

import * as echarts from "echarts";

import "./assets/iconfont/iconfont.css";
// 引入基本模板
// hls视频直播
// 引入柱状图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
Vue.prototype.$echarts = echarts;

// 视频播放
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
// import 'videojs-contrib-hls'

Vue.use(VideoPlayer);
promise.polyfill();
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

// 监听浏览器窗口发生变化
import visibility from "vue-visibility-change";
Vue.use(visibility);

Vue.config.productionTip = false;
Vue.use(install);
Vue.use(ElementUI);
Vue.use(uploader);
Vue.component("Icon", Icon);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js